<template>
  <div v-if="detail.id" class="face-page">
    <div class="top-info-box">
      <img src="@static/images/order/info-icon.png" class="" />
      <span
        >为了保障您的合法权益，需要对您进行身份认证，请投保人<strong>{{ detail.policyerName }}</strong
        >进行人脸识别</span
      >
    </div>
    <div class="res-box">
      <img src="@static/images/order/refund/face-top.png" class="face-img-top" />
      <div class="face-desc">1.请确认由本人亲自操作；</div>
      <div class="face-desc">2.请将脸至于提示框内，并按提示完成动作。</div>
      <div class="face-tips">
        <div class="face-tip-li">
          <img src="@static/images/order/refund/face-1.png" />
          正对手机
        </div>
        <div class="face-tip-li">
          <img src="@static/images/order/refund/face-2.png" />
          光线充足
        </div>
        <div class="face-tip-li">
          <img src="@static/images/order/refund/face-3.png" />
          放慢动作
        </div>
      </div>
    </div>
    <div class="res-box" v-if="face != 1">
      <div class="xy-box" @click="$refs.xyFacePopup.open()">
        <div class="radio" :class="{ 'active': radio }">
          <i class="icon-tongguo"></i>
        </div>
        <div>我已阅读并同意</div>
        <div class="blue">《客户信息授权声明》</div>
      </div>
      <div class="submit-btn" @click="start">开始识别</div>
    </div>

    <!-- 协议声明 -->
    <xyFacePopup ref="xyFacePopup" @ok="radio = true" />
  </div>
</template>
<script>
import xyFacePopup from './xyFacePopup';
export default {
  components: {
    xyFacePopup
  },
  mixins: [],
  props: {
    detail: null
  },
  data() {
    return {
      radio: false,
      errMsg: '',
      orderNo: '',
      face: 0 //是否完成人脸识别
    };
  },
  mounted() {
    this.face = this.$route.query.face;
    this.orderNo = this.$route.query.key;
    if (this.face == 1) {
      this.submit();
    } else if (sessionStorage.jumpTBxieyi == 1) {
      window.setTimeout(()=>{
        this.$refs.xyFacePopup.open();
      }, 500)
      sessionStorage.removeItem('jumpTBxieyi');
    }
  },
  methods: {
    start() {
      if (!this.radio) {
        this.$notice.msg('请先阅读并同意《客户信息授权声明》');
        return;
      }
      let applicationType;
      if (this.$tools.isWeiXin()) {
        //微信
        applicationType = 1;
      } else if (this.$config.isApp) {
        //app
        applicationType = 2;
      } else if (this.$tools.mobile) {
        //移动端
        applicationType = 4;
      } else {
        //pc
        this.$notice.msg('暂不支持PC');
        return;
      }
      var loadingObj = this.$notice.loading('加载中...');
      let url = location.href;
      if (!url.includes('&face=1')) {
        url += '&face=1';
      }
      this.$http({
        type: 'GET',
        url: '/api/refund/startFace',
        data: {
          orderNo: this.orderNo,
          applicationType
        }
      })
        .then(data => {
          location.href = data.data;
        })
        .finally(() => {
          this.$notice.close(loadingObj);
        });
    },
    submit() {
      let applicationType;
      if (this.$tools.isWeiXin()) {
        //微信
        applicationType = 1;
      } else if (this.$config.isApp) {
        //app
        applicationType = 2;
      } else if (this.$tools.mobile) {
        //移动端
        applicationType = 4;
      } else {
        //pc
        this.$notice.msg('暂不支持PC');
        return;
      }
      var loadingObj = this.$notice.loading('加载中...');
      this.$http({
        type: 'GET',
        url: '/api/refund/faceEnd',
        data: {
          orderNo: this.orderNo,
          applicationType
        }
      })
        .then(res => {
          const data = res.data;
          if (data.resultFlag == 'true' && data.edorState == '待人工复核') {
            sessionStorage.refundStaus = 'waitAudit';
          } else {
            sessionStorage.refundStaus = 'complete';
          }
          this.$emit('next');
          this.$notice.close(loadingObj);
        })
        .catch(() => {
          this.face = 0;
          this.$notice.close(loadingObj);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.face-page {
  padding-bottom: 50px;
}
.error-msg {
  width: 100%;
  padding: 10px;
  font-size: 24px;
  line-height: 40px;
  color: #fe3a3a;
  background-color: #fff3f3;
}
.res-box {
  padding: 20px 30px 0;
  background-color: #fff;
}
.top-info-box {
  background: #f7f7f7;
  border-radius: 8px;
  height: 110px;
  padding: 20px;
  font-size: 24px;
  color: #666666;
  display: flex;
  margin: 0 30px 20px;
  img {
    width: 24px;
    height: 24px;
    min-width: 24px;
    margin-top: 3px;
    margin-right: 4px;
  }
  strong {
    color: #236dff;
  }
}
.face-img-top {
  width: 340px;
  height: 340px;
  margin: 0 auto 30px;
  display: block;
}
.face-desc {
  color: #666;
  font-size: 28px;
  line-height: 60px;
  padding-left: 20px;
}
.face-tips {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 20px;
  margin-bottom: 30px;
  .face-tip-li {
    width: 30%;
    font-size: 24px;
    color: #888;
    text-align: center;
    img {
      width: 100px;
      display: block;
      margin: 10px auto;
    }
  }
}
.submit-btn {
  width: 90%;
  height: 80px;
  margin: 10px auto;
  background-color: #236dff;
  color: #fff;
  border-radius: 80px;
  font-size: 34px;
  text-align: center;
  line-height: 80px;
}
.xy-box {
  width: 90%;
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #3c464f;
  margin: auto;
  margin-bottom: 20px;
  .radio {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #ddd;
    margin-right: 12px;
    &.active {
      background-color: #00b01c;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 2px;
      i {
        visibility: visible;
        font-size: 12px;
        color: #fff;
        line-height: 1;
      }
    }
    i {
      visibility: hidden;
    }
  }
}
.blue {
  color: #236dff;
}
</style>
